export function GetObjectUrl(resourceGroupId: string, objectId: string) {
    return `/objects/${resourceGroupId}/${objectId}`;
}